import type { ReactNode } from 'react'
import { HoverHelp } from '@/tableControls'

export default function SettingsIntegrationSection({
  title,
  detail,
  icon,
  children,
}: {
  title: string
  detail?: ReactNode
  icon?: ReactNode
  children: ReactNode
}) {
  return (
    <section className="rounded-xl border border-gray-200 bg-white shadow-sm shadow-gray-950/[0.04]">
      <div className="border-b border-gray-100 bg-gradient-to-b from-gray-50/90 to-gray-50/30 px-6 py-4">
        <div className="flex items-center gap-3">
          {icon ? <div className="flex-shrink-0">{icon}</div> : null}
          <div className="flex min-w-0 flex-1 items-center gap-2">
            {detail ? (
              <h2 className="text-base font-semibold leading-snug tracking-tight text-gray-900">
                <HoverHelp label={title} aria-label={`Learn more: ${title}`}>
                  {detail}
                </HoverHelp>
              </h2>
            ) : (
              <h2 className="text-base font-semibold leading-snug tracking-tight text-gray-900">
                {title}
              </h2>
            )}
          </div>
        </div>
      </div>
      <div className="p-6 sm:p-7 lg:p-8">{children}</div>
    </section>
  )
}
